import { styled } from '@fluentui/react';
import { LoadingPaneBase } from './loading-pane.base';
import { getLoadingPaneStyles } from './loading-pane.style';
export const LoadingPane = styled(LoadingPaneBase, getLoadingPaneStyles, undefined, { scope: 'LoadingPane' });
//# sourceMappingURL=loading-pane.js.map